// extracted by mini-css-extract-plugin
module.exports = {"headerBase":"StudioGame_headerBase__2Rg99","linksBase":"StudioGame_linksBase__2tmGz","displayFlex":"StudioGame_displayFlex__BZ8-K","listsBase":"StudioGame_listsBase__1nLZ_"};